export default __webpack_public_path__ + "static/media/icon-lupa.aa3ff375.svg";